
(function(){
  "use strict";

  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));

  function money(cents){
    const currency=(window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    try{
      return new Intl.NumberFormat(document.documentElement.lang || "en-US",{style:"currency",currency}).format((Number(cents)||0)/100);
    }catch(e){
      return "$"+((Number(cents)||0)/100).toFixed(2);
    }
  }

  /* Mobile navigation */
  const menuBtn=$("[data-mobile-menu-toggle]");
  const nav=$("#GuardzNav");
  if(menuBtn && nav){
    menuBtn.addEventListener("click",()=>{
      const open=nav.classList.toggle("is-open");
      menuBtn.setAttribute("aria-expanded",String(open));
    });
  }

  /* Intro: trace + GUARDZ + blue zoom portal into live storefront */
  function initIntro(){
    const intro=$("#GuardzIntro");
    if(!intro) return;

    let running=false;
    let timers=[];

    const status=$("#GuardzIntroStatus");
    const pct=$("#GuardzIntroPercent");
    const dot=$("#GuardzIntroDot");
    const skip=$("#GuardzIntroSkip");

    const clearTimers=()=>{
      timers.splice(0).forEach(clearTimeout);
    };
    const later=(fn,ms)=>timers.push(setTimeout(fn,ms));

    function resetIntro(){
      clearTimers();
      intro.hidden=false;
      intro.setAttribute("aria-hidden","false");
      intro.classList.remove("is-running","is-zooming","is-done");
      if(status) status.textContent="GUARDZ // INITIALIZING COLLECTOR PROTECTION SYSTEMS";
      if(pct) pct.textContent="00%";
      if(dot) dot.classList.remove("is-live");
      document.body.classList.add("gz-intro-active");
      void intro.offsetWidth;
    }

    function finish(skipZoom){
      if(!running) return;
      clearTimers();

      if(skipZoom){
        intro.classList.add("is-done");
        document.body.classList.remove("gz-intro-active");
        setTimeout(()=>{
          intro.hidden=true;
          intro.setAttribute("aria-hidden","true");
          running=false;
        },380);
        return;
      }

      intro.classList.add("is-zooming");
      setTimeout(()=>{
        document.body.classList.remove("gz-intro-active");
        intro.classList.add("is-done");
        setTimeout(()=>{
          intro.hidden=true;
          intro.setAttribute("aria-hidden","true");
          running=false;
        },360);
      },820);
    }

    function playIntro(){
      if(running) return;
      running=true;
      resetIntro();
      requestAnimationFrame(()=>intro.classList.add("is-running"));

      later(()=>{if(pct) pct.textContent="18%";if(status) status.textContent="GUARDZ // TRACING PROTECTION FRAME";},520);
      later(()=>{if(pct) pct.textContent="39%";if(status) status.textContent="GUARDZ // LOADING SYSTEM GEOMETRY";},1030);
      later(()=>{if(pct) pct.textContent="61%";if(status) status.textContent="GUARDZ // VERIFYING MATERIAL PROFILE";},1640);
      later(()=>{if(pct) pct.textContent="82%";if(status) status.textContent="GUARDZ // CONNECTING STOREFRONT";},2280);
      later(()=>{
        if(pct) pct.textContent="100%";
        if(status) status.textContent="GUARDZ // SYSTEM ONLINE";
        if(dot) dot.classList.add("is-live");
      },3150);
      later(()=>finish(false),3500);
    }

    /*
      V11 behavior: play on every document load. The GuardZ storefront uses in-page
      navigation and an Ajax cart, so normal site navigation does not reload the
      document and therefore does not replay or interrupt the shopping experience.
    */
    if(skip) skip.addEventListener("click",()=>finish(true));
    playIntro();
  }

  /* Mirror date-filtered Shopify shows in the original show-poster layout.
     The poster heading follows the month when all shown events share one month. */
  function syncHeroShows(){
    const source=$("#shows .gz-show-sign__schedule");
    if(!source) return;

    const shows=$$(".gz-show-sign__row",source).slice(0,5).map(row=>{
      const dateNode=$(".gz-show-sign__date",row);
      return {
        date:(dateNode?.firstChild?.textContent || "TBA").trim() || "TBA",
        name:($(".gz-show-sign__event",row)?.textContent || "").trim(),
        location:($(".gz-show-sign__location",row)?.innerText || "").replace(/\s+/g," ").trim()
      };
    });

    const monthNames=["January","February","March","April","May","June", "July","August","September","October","November","December"];
    function getShowMonth(dateLabel){
      const match=dateLabel.match(/^\s*(\d{1,2})\s*\//);
      if(match){
        const month=Number(match[1]);
        if(month>=1 && month<=12) return monthNames[month-1];
      }
      const normalized=dateLabel.trim().toLowerCase();
      return monthNames.find(month=>normalized.startsWith(month.toLowerCase()) || normalized.startsWith(month.slice(0,3).toLowerCase())) || null;
    }

    const actualShows=shows.filter(show=>show.date.toUpperCase()!=="TBA" && !/^new dates coming soon$/i.test(show.name));
    const months=actualShows.map(show=>getShowMonth(show.date));
    const oneMonth=months.length>0 && months.every(month=>month && month===months[0]);
    const heading=oneMonth ? months[0]+" Shows" : "Upcoming Shows";
    $$("[data-hero-shows-title]").forEach(title=>{ title.textContent=heading; });

    $$("[data-hero-shows-schedule]").forEach(schedule=>{
      const fragment=document.createDocumentFragment();
      shows.forEach(show=>{
        const row=document.createElement("div");
        const date=document.createElement("b");
        const details=document.createElement("em");
        date.textContent=show.date;
        details.textContent=[show.name,show.location].filter(Boolean).join(" — ");
        row.append(date,details);
        fragment.appendChild(row);
      });
      if(shows.length) schedule.replaceChildren(fragment);
    });
  }

  /* Hero carousel */
  function initHero(){
    syncHeroShows();
    $$("[data-guardz-hero]").forEach(section=>{
      const slides=$$("[data-hero-slide]",section);
      if(slides.length<1) return;
      const dots=$("#GuardzHeroDots",section) || $("[data-hero-dots]",section);
      let index=0,timer=null;

      if(dots){
        dots.innerHTML="";
        slides.forEach((_,i)=>{
          const b=document.createElement("button");
          b.type="button";
          b.setAttribute("aria-label","Go to slide "+(i+1));
          b.addEventListener("click",()=>go(i,true));
          dots.appendChild(b);
        });
      }
      const dotButtons=dots ? $$("button",dots) : [];

      function go(i,user){
        slides[index].classList.remove("is-active");
        dotButtons[index]?.classList.remove("is-active");
        index=(i+slides.length)%slides.length;
        slides[index].classList.add("is-active");
        dotButtons[index]?.classList.add("is-active");
        if(user) reset();
      }
      function reset(){
        clearInterval(timer);
        timer=setInterval(()=>go(index+1,false),6500);
      }

      $("[data-hero-prev]",section)?.addEventListener("click",()=>go(index-1,true));
      $("[data-hero-next]",section)?.addEventListener("click",()=>go(index+1,true));
      go(0,false);
      reset();
      section.addEventListener("mouseenter",()=>clearInterval(timer));
      section.addEventListener("mouseleave",reset);
    });
  }

  /* Cart */
  const drawer=$("#GuardzCartDrawer");
  const overlay=$("#GuardzCartOverlay");
  function openCart(){
    if(!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden","false");
    if(overlay) overlay.hidden=false;
    renderCart();
  }
  function closeCart(){
    drawer?.classList.remove("is-open");
    drawer?.setAttribute("aria-hidden","true");
    if(overlay) overlay.hidden=true;
  }
  $$("[data-cart-open]").forEach(b=>b.addEventListener("click",openCart));
  $$("[data-cart-close]").forEach(b=>b.addEventListener("click",closeCart));
  overlay?.addEventListener("click",closeCart);
  document.addEventListener("keydown",e=>{if(e.key==="Escape")closeCart();});

  async function fetchCart(){
    const r=await fetch(window.guardzRoutes.cart,{headers:{"Accept":"application/json"}});
    if(!r.ok) throw new Error("Could not load cart");
    return r.json();
  }
  async function renderCart(){
    if(!drawer) return;
    try{
      const cart=await fetchCart();
      const items=$("#GuardzCartItems");
      const count=$("#GuardzCartCount");
      const total=$("#GuardzCartTotal");
      const shipCopy=$("#GuardzShippingCopy");
      const shipBar=$("#GuardzShippingBar");
      if(count) count.textContent=cart.item_count;
      if(total) total.textContent=money(cart.total_price);

      const threshold=Number(window.guardzTheme.freeShippingThreshold||9900);
      const pct=Math.max(0,Math.min(100,(cart.total_price/threshold)*100));
      if(shipBar) shipBar.style.width=pct+"%";
      if(shipCopy){
        shipCopy.textContent=cart.total_price>=threshold
          ? "Free shipping unlocked."
          : money(threshold-cart.total_price)+" until free shipping";
      }

      if(!items) return;
      if(!cart.items.length){
        items.innerHTML='<p class="gz-muted">Your cart is empty.</p>';
        return;
      }

      items.innerHTML=cart.items.map((item,i)=>`
        <div class="gz-cart-line">
          <img src="${item.image || ""}" alt="">
          <div>
            <h3>${escapeHtml(item.product_title)}</h3>
            ${(()=>{
              const properties=Object.entries(item.properties||{}).filter(([key,value])=>value && !String(key).startsWith("_"));
              if(properties.length){
                return `<p>${properties.map(([key,value])=>`${escapeHtml(key)}: ${escapeHtml(value)}`).join(" · ")}</p>`;
              }
              return item.variant_title && item.variant_title!=="Default Title" ? `<p>${escapeHtml(item.variant_title)}</p>` : "";
            })()}
            <div class="gz-cart-line__qty">
              <button type="button" data-cart-qty="${i+1}" data-qty="${Math.max(0,item.quantity-1)}">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty="${i+1}" data-qty="${item.quantity+1}">+</button>
            </div>
          </div>
          <div>
            <strong>${money(item.final_line_price)}</strong>
            <button type="button" class="gz-cart-line__remove" data-cart-qty="${i+1}" data-qty="0">Remove</button>
          </div>
        </div>
      `).join("");

      $$("[data-cart-qty]",items).forEach(btn=>btn.addEventListener("click",async()=>{
        btn.disabled=true;
        await changeCart(Number(btn.dataset.cartQty),Number(btn.dataset.qty));
        renderCart();
      }));
    }catch(e){
      $("#GuardzCartItems").innerHTML='<p class="gz-muted">Cart could not be loaded. <a href="'+window.guardzRoutes.cartPage+'">Open cart page.</a></p>';
    }
  }
  async function changeCart(line,quantity){
    await fetch(window.guardzRoutes.cartChange,{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({line,quantity})
    });
  }
  async function addToCart(variantId,quantity=1,properties=null){
    const item={id:Number(variantId),quantity:Number(quantity)||1};
    if(properties && typeof properties==="object"){
      item.properties=Object.fromEntries(Object.entries(properties).filter(([,value])=>value!==undefined&&value!==null&&String(value).trim()!==""));
    }
    const r=await fetch(window.guardzRoutes.cartAdd,{
      method:"POST",
      headers:{"Content-Type":"application/json","Accept":"application/json"},
      body:JSON.stringify({items:[item]})
    });
    if(!r.ok) throw new Error("Add to cart failed");
    await renderCart();
    openCart();
  }
  $$("[data-quick-add]").forEach(btn=>btn.addEventListener("click",async()=>{
    const old=btn.textContent;
    btn.disabled=true; btn.textContent="Adding…";
    try{await addToCart(btn.dataset.quickAdd);}
    catch(e){btn.textContent="Try again";setTimeout(()=>btn.textContent=old,1600);}
    finally{btn.disabled=false;}
  }));
  function escapeHtml(str){
    return String(str??"").replace(/[&<>"']/g,m=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#039;"}[m]));
  }

  /* PSA, CGC, and TAG use one protector size. Beckett/BGS is separate. */
  function canonicalGrader(value){
    const v=String(value||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").trim().toLowerCase();
    if(/\b(beckett|bgs|bcg)\b/.test(v)) return "BECKETT_BGS";
    if(/\b(psa|cgc|tag)\b/.test(v)) return "PSA_CGC_TAG";
    return "";
  }

  function preferredGraderVariant(variants,group){
    const ranked=variants.slice().sort((a,b)=>{
      function rank(v){
        if(group!=="PSA_CGC_TAG") return 0;
        const option=(v.options||[]).find(o=>canonicalGrader(o)===group)||"";
        const name=String(option).toLowerCase();
        if(/\bpsa\b/.test(name)&&/\bcgc\b/.test(name)&&/\btag\b/.test(name)) return 0;
        if(/\bpsa\b/.test(name)) return 1;
        if(/\bcgc\b/.test(name)) return 2;
        if(/\btag\b/.test(name)) return 3;
        return 4;
      }
      return rank(a)-rank(b);
    });
    return ranked.find(v=>v.available)||ranked[0]||null;
  }

  /* Home GuardZ configurator */
  function initConfigurator(){
    const section=$("[data-guardz-configurator]");
    if(!section) return;
    const img=$("#GuardzConfiguratorImage",section);
    const notice=$("#GuardzBeckettNotice",section);
    const fitNotice=$("#Guardz35ptNotice",section);
    const price=$("#GuardzConfiguratorPrice",section);
    const variantInput=$("#GuardzConfiguratorVariantId",section);
    const add=$("[data-config-add]",section);
    const restock=$("[data-config-restock]",section);
    const grader=$("[data-guardz-grader]",section);
    const color=$("[data-guardz-color]",section);
    const matrixJson=$("[data-guardz-variant-matrix]",section);
    const mediaJson=$("[data-guardz-media-matrix]",section);
    const fallbackJson=$("[data-guardz-fallback-images]",section);
    const viewButtons=$$("[data-config-view-name]",section);
    let variants=[];
    let media=[];
    let fallback={};
    try{variants=matrixJson?JSON.parse(matrixJson.textContent):[];}catch(e){variants=[];}
    try{media=mediaJson?JSON.parse(mediaJson.textContent):[];}catch(e){media=[];}
    try{fallback=fallbackJson?JSON.parse(fallbackJson.textContent):{};}catch(e){fallback={};}

    const stripMarks=value=>String(value||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").trim().toLowerCase();


    function canonicalColor(value){
      const v=stripMarks(value).replace(/\s+/g," ");
      if(v==="blue 42"||v==="blue") return "BLUE_42";
      if(v==="varsity blue"||v==="dark blue"||v==="navy") return "VARSITY_BLUE";
      if(v==="blue chip"||v==="light blue"||v==="aqua"||v==="cyan") return "BLUE_CHIP";
      if(v==="blackout"||v==="black") return "BLACKOUT";
      if(v==="pink october"||v==="rose red") return "PINK_OCTOBER";
      if(v==="pink rose"||v==="pink") return "PINK_ROSE";
      if(v==="showtime purple"||v==="purple") return "SHOWTIME_PURPLE";
      if(v==="tactical green"||v==="light green") return "TACTICAL_GREEN";
      if(v==="turf green"||v==="green") return "TURF_GREEN";
      if(v==="red zone"||v==="red") return "RED_ZONE";
      if(v==="silver slugger"||v==="silver"||v==="clear") return "SILVER_SLUGGER";
      if(v==="gold medal"||v==="gold") return "GOLD_MEDAL";
      if(v==="orange fury"||v==="orange") return "ORANGE_FURY";
      if(v==="yellow card"||v==="yellow") return "YELLOW_CARD";
      return "";
    }

    function classifyVariant(variant){
      let graderKey="",colorKey="";
      (variant.options||[]).forEach(option=>{
        graderKey=graderKey||canonicalGrader(option);
        colorKey=colorKey||canonicalColor(option);
      });
      return {graderKey,colorKey};
    }

    const indexedVariants=variants.map(variant=>Object.assign({},variant,classifyVariant(variant)));

    /* Asset fallbacks are allowed only for a verified slab group + color + view.
       An unqualified color fallback could display a PSA photo on a Beckett choice. */
    const fallbackIndex={};
    Object.entries(fallback).forEach(([key,views])=>{
      const parts=key.split("|");
      if(parts.length!==2) return;
      const groupKey=canonicalGrader(parts[0]);
      const colorKey=canonicalColor(parts[1]);
      if(groupKey&&colorKey&&views&&typeof views==="object"){
        fallbackIndex[groupKey+"|"+colorKey]=views;
      }
    });

    function fallbackFor(graderKey,colorKey){
      return fallbackIndex[graderKey+"|"+colorKey]||{};
    }

    function canonicalView(value){
      const v=stripMarks(value);
      if(v==="front") return "front";
      if(v==="open") return "open";
      if(v==="card") return "card";
      if(v==="psa") return "psa";
      if(v==="cgc") return "cgc";
      if(v==="tag") return "tag";
      return "";
    }

    /* Shopify product-media alt text is authoritative; CDN filenames are not.
       Accepted format: GZ | grader | color | view. */
    function parseTaggedMediaAlt(alt){
      const parts=String(alt||"").split("|").map(part=>part.trim());
      if(parts.length===4){
        if(!/^(gz|guardz)$/i.test(parts[0])) return null;
        parts.shift();
      }
      if(parts.length!==3) return null;
      const sourceGrader=stripMarks(parts[0]);
      const graderKey=canonicalGrader(parts[0]);
      const colorKey=canonicalColor(parts[1]);
      const sourceView=canonicalView(parts[2]);
      if(!graderKey||!colorKey||!sourceView) return null;
      let viewKey=sourceView;
      if(graderKey==="PSA_CGC_TAG"){
        // Legacy "Card" describes the specific grader in the alt grader token.
        // Keep these photos in distinct PSA, CGC and TAG slots, never a shared Card slot.
        if(sourceView==="card"){
          if(sourceGrader==="psa"||sourceGrader==="cgc"||sourceGrader==="tag") viewKey=sourceGrader;
          else return null;
        }
      }else if(!["front","open","card"].includes(sourceView)){
        return null;
      }
      // An explicit final PSA/CGC/TAG view takes precedence over legacy "Card".
      // Shared-grader FRONT and OPEN photographs are interchangeable across PSA/CGC/TAG.
      const preference=sourceView==="card" ? 1 :
        (sourceView==="front"||sourceView==="open") && graderKey==="PSA_CGC_TAG" ?
          (sourceGrader==="psa"?12:sourceGrader==="cgc"?11:sourceGrader==="tag"?10:13) : 20;
      return {graderKey,colorKey,viewKey,preference};
    }

    const mediaIndex={};
    const mediaPreference={};
    media.forEach(item=>{
      const parsed=parseTaggedMediaAlt(item.alt);
      if(!parsed||!item.src) return;
      const key=parsed.graderKey+"|"+parsed.colorKey;
      const slot=key+"|"+parsed.viewKey;
      if((mediaPreference[slot]??-1)>=parsed.preference) return;
      if(!mediaIndex[key]) mediaIndex[key]={};
      mediaIndex[key][parsed.viewKey]=item.src;
      mediaPreference[slot]=parsed.preference;
    });

    function taggedViews(graderKey,colorKey){
      return mediaIndex[graderKey+"|"+colorKey]||{};
    }

    function updateViews(views,graderKey){
      if(!img) return;
      let activeButton=null;
      viewButtons.forEach(btn=>{
        const group=btn.dataset.configViewGroup;
        btn.hidden=(group==="psa" && graderKey!=="PSA_CGC_TAG") ||
          (group==="beckett" && graderKey!=="BECKETT_BGS");
        const url=views[btn.dataset.configViewName]||"";
        if(!btn.hidden && url){
          btn.dataset.configView=url;
          btn.disabled=false;
          btn.setAttribute("aria-disabled","false");
          if(!activeButton) activeButton=btn;
        }else{
          delete btn.dataset.configView;
          btn.disabled=true;
          btn.setAttribute("aria-disabled","true");
        }
      });
      if(activeButton){
        img.src=activeButton.dataset.configView;
        img.hidden=false;
      }else{
        img.removeAttribute("src");
        img.hidden=true;
      }
      const unavailable=$("#GuardzConfiguratorImageUnavailable",section);
      if(unavailable) unavailable.hidden=!!activeButton;
      viewButtons.forEach(btn=>{
        const active=btn===activeButton;
        btn.classList.toggle("is-active",active);
        btn.setAttribute("aria-pressed",String(active));
      });
    }

    viewButtons.forEach(btn=>btn.addEventListener("click",()=>{
      if(btn.hidden||btn.disabled||!btn.dataset.configView) return;
      img.src=btn.dataset.configView;
      viewButtons.forEach(b=>{
        const active=b===btn;
        b.classList.toggle("is-active",active);
        b.setAttribute("aria-pressed",String(active));
      });
    }));

    function findVariant(){
      if(!grader||!color) return;
      const displayGrader=grader.value;
      const displayColor=color.value;
      const graderKey=canonicalGrader(displayGrader);
      const colorKey=canonicalColor(displayColor);
      const variant=preferredGraderVariant(indexedVariants.filter(v=>v.graderKey===graderKey&&v.colorKey===colorKey),graderKey);
      if(notice) notice.hidden=graderKey!=="BECKETT_BGS";
      if(fitNotice) fitNotice.hidden=graderKey==="BECKETT_BGS";

      const fallbackData=fallbackFor(graderKey,colorKey);
      const tagged=taggedViews(graderKey,colorKey);
      // Only the exact matching tagged view (or a verified, group-specific
      // color+view asset) can be displayed. Never use variant.featured_image,
      // a generic grader upload, or a neighboring color as a substitute.
      const views={
        front:tagged.front||fallbackData.front||"",
        open:tagged.open||fallbackData.open||"",
        card:graderKey==="BECKETT_BGS" ? tagged.card||fallbackData.card||"" : "",
        psa:graderKey==="PSA_CGC_TAG" ? tagged.psa||"" : "",
        cgc:graderKey==="PSA_CGC_TAG" ? tagged.cgc||"" : "",
        tag:graderKey==="PSA_CGC_TAG" ? tagged.tag||"" : ""
      };
      if(variant){
        if(variantInput) variantInput.value=variant.id;
        if(price) price.textContent=money(variant.price);
        if(add){
          add.disabled=!variant.available;
          add.textContent=variant.available?"Add to cart":"Restocking soon";
        }
        if(restock) restock.hidden=variant.available;
      }else{
        if(variantInput) variantInput.value="";
        if(add){add.disabled=true;add.textContent="Unavailable";}
        if(restock) restock.hidden=true;
      }
      updateViews(views,graderKey);
      return variant;
    }

    grader?.addEventListener("change",findVariant);
    color?.addEventListener("change",findVariant);
    add?.addEventListener("click",async()=>{
      const variant=findVariant();
      if(!variant||!variant.available||!variantInput?.value) return;
      const old=add.textContent;
      add.disabled=true;
      add.textContent="Adding…";
      try{
        await addToCart(variantInput.value,1,{
          "Slab Type / Grader":grader.value,
          "Color":color.value
        });
      }catch(e){
        add.textContent="Try again";
        setTimeout(()=>{add.textContent=old;add.disabled=!variant.available;},1600);
        return;
      }
      add.textContent=variant.available?old:"Restocking soon";
      add.disabled=!variant.available;
      if(restock) restock.hidden=variant.available;
    });
    findVariant();
  }

  /* Product page */
  function initProductPage(){
    const section=$("[data-main-product]");
    if(!section) return;
    const json=$("[data-main-product-json]",section);
    const variantSelect=$("[data-main-variant-select]",section);
    const optionSelects=$$("[data-main-product-option]",section);
    const price=$("[data-product-price]",section);
    const add=$("[data-main-add]",section);
    const restock=$("[data-main-restock]",section);
    const notice=$("[data-product-beckett-notice]",section);
    const form=$("#GuardzProductForm",section);
    const hero=$("#MainProductImage",section);
    $$("[data-product-image]",section).forEach(btn=>btn.addEventListener("click",()=>{if(hero)hero.src=btn.dataset.productImage;}));
    if(!json || !variantSelect) return;
    const product=JSON.parse(json.textContent);
    // Group only a grading option offering BOTH physical protector formats.
    // All other product options (for example toploader sizes) stay untouched.
    const graderIndex=optionSelects.findIndex(select=>{
      const groups=Array.from(select.options).map(o=>canonicalGrader(o.value));
      return groups.includes("PSA_CGC_TAG")&&groups.includes("BECKETT_BGS");
    });
    if(graderIndex!==-1){
      const select=optionSelects[graderIndex];
      const initialGroup=canonicalGrader(select.value)||"PSA_CGC_TAG";
      select.replaceChildren(new Option("PSA / CGC / TAG","PSA / CGC / TAG"),new Option("Beckett / BGS","Beckett / BGS"));
      select.value=initialGroup==="BECKETT_BGS"?"Beckett / BGS":"PSA / CGC / TAG";
    }
    function sync(){
      const selected=optionSelects.map(s=>s.value);
      let variant;
      if(graderIndex!==-1){
        const group=canonicalGrader(selected[graderIndex]);
        const choices=product.variants.filter(v=>v.options.every((o,i)=>
          i===graderIndex ? canonicalGrader(o)===group : String(o)===String(selected[i])
        ));
        variant=preferredGraderVariant(choices,group);
      }else{
        variant=product.variants.find(v=>v.options.every((o,i)=>String(o)===String(selected[i])))
          || product.variants.find(v=>String(v.id)===String(variantSelect.value));
      }
      if(notice) notice.hidden=!selected.some(v=>/beckett|bgs|bcg/i.test(v));
      if(!variant){
        variantSelect.value="";
        if(add){add.disabled=true;add.textContent="Unavailable";}
        if(restock) restock.hidden=true;
        return;
      }
      variantSelect.value=variant.id;
      if(price) price.textContent=money(variant.price);
      if(add){add.disabled=!variant.available;add.textContent=variant.available?"Add to cart":"Restocking soon";}
      if(restock) restock.hidden=variant.available;
      if(hero && variant.featured_image && variant.featured_image.src) hero.src=variant.featured_image.src;
    }
    optionSelects.forEach(s=>s.addEventListener("change",sync));
    form?.addEventListener("submit",async e=>{
      e.preventDefault();
      const q=Number($('input[name="quantity"]',form)?.value||1);
      const properties=graderIndex!==-1?{"Slab Type / Grader":optionSelects[graderIndex].value}:null;
      try{await addToCart(variantSelect.value,q,properties);}catch(err){form.submit();}
    });
    sync();
  }

  /* Color Match */
  function initColorMatch(){
    const section=$("[data-color-match]");
    if(!section) return;
    const upload=$("[data-color-upload]",section);
    const select=$("[data-color-select]",section);
    const slab=$("[data-preview-slab]",section);
    const photo=$("[data-preview-photo]",section);
    const result=$("[data-color-result]",section);
    const colors={
      "Blue 42":"#1268e8",
      "Varsity Blue":"#0d2d5c",
      "Blue Chip":"#27bdf2",
      "Blackout":"#111418",
      "Pink Rosè":"#e783a9",
      "Pink October":"#d84f76",
      "Showtime Purple":"#6e3aa8",
      "Turf Green":"#0a9f52",
      "Tactical Green":"#7da44b",
      "Red Zone":"#d92d35",
      "Silver Slugger":"#c4c9cd",
      "Gold Medal":"#c49a24",
      "Orange Fury":"#e87512",
      "Yellow Card":"#f1c400"
    };
    function apply(name){
      if(!colors[name]) name="Blackout";
      select.value=name;
      slab.style.borderColor=colors[name];
    }
    apply("Blackout");
    select.addEventListener("change",()=>apply(select.value));
    upload.addEventListener("change",e=>{
      const file=e.target.files && e.target.files[0];
      if(!file) return;
      const url=URL.createObjectURL(file);
      photo.src=url;
      const image=new Image();
      image.onload=()=>{
        const canvas=document.createElement("canvas");
        const width=96,height=128;
        canvas.width=width;canvas.height=height;
        const ctx=canvas.getContext("2d",{willReadFrequently:true});

        /* Focus Color Match on the card artwork, not the graded-slab shell/label. */
        const sx=image.naturalWidth*.10;
        const sy=image.naturalHeight*.22;
        const sw=image.naturalWidth*.80;
        const sh=image.naturalHeight*.70;
        ctx.drawImage(image,sx,sy,sw,sh,0,0,width,height);

        const data=ctx.getImageData(0,0,width,height).data;
        const palette=Object.entries(colors).map(([name,hex])=>({
          name,
          r:parseInt(hex.slice(1,3),16),
          g:parseInt(hex.slice(3,5),16),
          b:parseInt(hex.slice(5,7),16)
        }));
        const chromaticPalette=palette.filter(color=>color.name!=="Silver Slugger");
        const votes=Object.fromEntries(palette.map(color=>[color.name,0]));
        let sampled=0,chromatic=0,lightNeutral=0;

        for(let y=0;y<height;y+=2){
          for(let x=0;x<width;x+=2){
            const i=(y*width+x)*4;
            if(data[i+3]<100) continue;
            const r=data[i],g=data[i+1],b=data[i+2];
            const max=Math.max(r,g,b),min=Math.min(r,g,b);
            const chroma=max-min;
            const luminance=.2126*r+.7152*g+.0722*b;
            sampled++;

            if(chroma>=34 && max>45){
              chromatic++;
              let nearest="Blackout",nearestDist=Infinity;
              chromaticPalette.forEach(color=>{
                const d=(r-color.r)**2+(g-color.g)**2+(b-color.b)**2;
                if(d<nearestDist){nearestDist=d;nearest=color.name;}
              });
              let weight=1+1.5*(chroma/255);
              if(luminance>235) weight*=.35;
              votes[nearest]+=weight;
            }else if(luminance<80){
              /* Preserve dark/black cards without letting gray slab plastic dominate. */
              votes.Blackout+=.65;
            }else if(luminance>=125){
              lightNeutral++;
            }
          }
        }

        /* Silver is eligible only when the cropped card area itself is overwhelmingly neutral. */
        if(sampled && chromatic/sampled<.10) votes["Silver Slugger"]+=lightNeutral*.8;

        let best="Blackout",bestScore=-1;
        Object.entries(votes).forEach(([name,score])=>{
          if(score>bestScore){bestScore=score;best=name;}
        });
        apply(best);
        result.innerHTML='<span class="gz-micro">Color Match Recommendation</span><strong>'+best+'</strong><p>Previewing '+best+' based on the dominant tones in your photo. Try any other finish from the menu above.</p>';
      };
      image.src=url;
    });
  }

  function initGuardzTheme(){
    initIntro();
    initHero();
    initConfigurator();
    initProductPage();
    initColorMatch();
    renderCart();
  }

  document.addEventListener("shopify:section:load",syncHeroShows);
  document.addEventListener("shopify:section:reorder",syncHeroShows);

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded",initGuardzTheme,{once:true});
  }else{
    initGuardzTheme();
  }
})();
